import categories from "@/data/blog/lib/categories.json";
import legacyRoutes from "@/data/blog/legacy-category-routes.json";
import navmenu from "@/data/navmenu.json";
import type { Lang } from "@/lib/types";

/** Canonical category identities come from categories.json; localized slugs retain Nuxt parity. */
export function getBlogCategorySegment(lang: Lang): string {
  return navmenu.main.find((item) => item.en?.customPath === "categories")?.[lang]?.url ?? "categories";
}

export function getBlogCategoryPathSlug(category: string, lang: Lang): string | null {
  if (!categories.some((row) => row.slug === category)) return null;
  const alias = Object.entries(legacyRoutes).find(([, row]) => row.lang === lang && "category" in row && row.category === category);
  return alias?.[0].split("/").filter(Boolean).at(-1) ?? category;
}

export function resolveBlogCategorySegments(segments: string[], lang: Lang): string | null {
  if (segments.length !== 2 || ![getBlogCategorySegment(lang), "categories", "kategorier"].includes(segments[0])) return null;
  let slug: string;
  try { slug = decodeURIComponent(segments[1]); } catch { return null; }
  return categories.find((row) => row.slug === slug || getBlogCategoryPathSlug(row.slug, lang) === slug)?.slug ?? null;
}

export function buildBlogCategoryPath(baseHref: string, category: string, lang: Lang): string {
  const slug = getBlogCategoryPathSlug(category, lang);
  return slug ? `${baseHref}/${getBlogCategorySegment(lang)}/${encodeURIComponent(slug)}` : baseHref;
}

export function categoryFromBlogPathname(pathname: string, baseHref: string, lang: Lang): string | null {
  if (!pathname.startsWith(`${baseHref}/`)) return null;
  return resolveBlogCategorySegments(pathname.slice(baseHref.length).split("/").filter(Boolean), lang);
}

export function listBlogCategorySlugs(): string[] {
  return categories.map((category) => category.slug);
}
